export const enum ClickPositionPrefix {
  category = 'category_',
  // article and video page immersive post
  inner = 'inner_',
  // article and video page related post single
  related = 'related_',
  experience = 'experience_',
  none = '',
}

export const enum ClickPosition {
  silent_awaken = 'silent_awaken',

  surprise_popup = 'web_surprise_popup',
  surprise_pendant = 'surprise_pendant',

  experience_question = 'experience_question',
  experience_answer = 'experience_answer',
  experience_seemore = 'experience_seemore',
  modal_close_arrow = 'modal_close_arrow',
  source_article_index = 'source_article_index',
  disclaimer = 'disclaimer',
  pwa_notification_banner = 'pwa_notification_banner',
  intercept_banner = 'intercept_banner',
  first_landing_dialog = 'first_landing_dialog',
  first_landing_dialog_mask = 'first_landing_dialog_mask',
  side_bar_homepage = 'side_bar_homepage',
  side_bar_pp = 'side_bar_pp',
  side_bar_tos = 'side_bar_tos',
  side_bar_cookie = 'side_bar_cookie',
  side_bar_avmsd = 'side_bar_avmsd',
  side_bar_download = 'side_bar_download',
  side_bar_category = 'side_bar_category',
  side_bar_email = 'side_bar_email',
  side_bar_osa = 'side_bar_osa',
  top_bar_logo = 'top_bar_logo',
  top_bar_side = 'top_bar_side',
  top_bar_share = 'top_bar_share',
  top_bar_search = 'top_bar_search',
  top_bar_download = 'top_bar_download',
  top_search_bar = 'top_search_bar',
  main_category = 'main_category',
  main_author = 'main_author',
  main_author_name = 'main_author_name',
  main_author_follow_btn = 'main_author_follow_btn',
  main_hashtag = 'main_hashtag',
  main_poi = 'main_poi',
  main_content_poi = 'main_content_poi',
  main_content_entity_word = 'main_content_entity_word',
  main_content_mentioned_user = 'main_content_mentioned_user',
  main_sar = 'main_sar',
  main_inner_link = 'main_inner_link',
  main_content_read_more = 'main_content_read_more',
  main_content_read_more_modal = 'main_content_read_more_modal',
  main_content_unfold_cta_btn = 'main_content_unfold_cta_btn',
  main_comment_send = 'main_comment_send',
  main_comment_icon = 'main_comment_icon',
  main_share_icon = 'main_share_icon',
  main_like_icon = 'main_like_icon',
  main_favorite_icon = 'main_favorite_icon',
  main_see_more_btn = 'main_see_more_btn',
  main_read_more = 'main_read_more',
  main_gallery_label = 'main_gallery_label',
  main_gallery_label_switcher = 'main_gallery_label_switcher',
  comment_author = 'comment_author',
  comment_image = 'comment_image',
  comment_like = 'comment_like',
  comment_reply = 'comment_reply',
  comment = 'comment',
  comment_modal = 'comment_modal',
  comment_text = 'comment_text',
  comment_modal_mask_close = 'comment_modal_mask_close',
  comment_modal_close = 'comment_modal_close',
  comment_mentioned_user = 'comment_mentioned_user',
  comment_see_more = 'comment_see_more',
  comment_reply_see_more = 'comment_reply_see_more',
  activity_banner = 'activity_banner',
  lemon8_banner = 'lemon8_banner',
  related_post = 'related_post',
  related_post_carousel = 'related_post_carousel',
  related_dialog = 'related_dialog',
  related_hashtag = 'related_hashtag',
  related_hashtag_with_article_card = 'related_hashtag_with_article_card',
  related_hashtag_article_card = 'related_hashtag_article_card',
  related_phone = 'related_phone',
  related_address = 'related_address',
  related_user = 'related_user',
  user_fans = 'user_fans',
  user_following = 'user_following',
  user_likes = 'user_likes',
  share_panel_icon = 'share_panel_icon',
  unknown = 'unknown',
  bottom_button = 'bottom_button',
  original_post_banner = 'original_post_banner',
  main_gallery_slide = 'main_gallery_slide',
  main_gallery_slide_modal = 'main_gallery_slide_modal',
  main_video_see_more = 'main_video_see_more',
  main_video_see_more_modal = 'main_video_see_more_modal',
  main_video_pause_auto = 'main_video_pause_auto',
  main_video_replay = 'main_video_replay',
  main_video_replay_modal = 'main_video_replay_modal',
  main_video_pause_manual = 'main_video_pause_manual',
  main_video_pause_manual_modal = 'main_video_pause_manual_modal',
  main_video_download_banner = 'main_video_download_banner',
  main_video_play = 'main_video_play',
  main_video_play_modal = 'main_video_play_modal',
  see_more_button = 'see_more_button',
  view_more_button = 'view_more_button',
  kep_breadcrumbs = 'kep_breadcrumbs',
  main_related_post = 'main_related_post',
  gallery_img = 'gallery_img',
  gallery_img_open = 'gallery_img_open',
  gallery_img_open_modal = 'gallery_img_open_modal',
  gallery_img_mask_open_btn = 'gallery_img_mask_open_btn',
  gallery_img_mask_close_btn = 'gallery_img_mask_close_btn',
  co_creator = 'co_creator',
  kep_classify_hot_keyword = 'kep_classify_hot_keyword',
  // pc reflow qrcode
  scan_code = 'scan_code',
  search_sug_item = 'search_sug_item',
  bottom_view_more_btn = 'bottom_view_more_btn',

  // the following string is concat by ClickPositionPrefix + ClickPosition
  // Please ensure the correctness of the value yourself

  category_related_post = 'category_related_post',
  category_view_more = 'category_view_more_button',
  category_see_more = 'category_see_more_button',
  related_search = 'related_search',
  bottom_sar_search = 'bottom_sar_search',
  kep_ai_overview = 'kep_ai_overview',
  kep_answer = 'kep_answer',
  kep_answer_see_more = 'kep_answer_see_more',
}
